import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {_imagenLogo} from '../imagenesBase64/logo'
import Swal from 'sweetalert2';
import {transformarIso8601,fechaActual} from '../Helpers/fechas';


const bkmonto = '';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export async function imprimir(datos, nombrePDF, tituloPDF,orientacion,parametros,tipoReporte){
    try{

        Swal.fire({
            html: 'Buscando...',
            timer: 600,
            onBeforeOpen: () => {
                Swal.showLoading()
            },
        }).then(data=>{
            generarDocumento(datos, nombrePDF, tituloPDF,orientacion ? orientacion : 'portrait',parametros,tipoReporte)
        })
    }catch(err){

            const mensaje_html = `<p>Hubo un error al generar el documento</p><p>${err}</p>`

            Swal.fire({
                html:mensaje_html,
                icon: 'warning',
                confirmButtonColor: '#3085d6',
            })
        }
}

function generarDocumento(datos,nombrePDF, tituloPDF,orientacion,parametros,tipoReporte) {

    let agrupado = {};
    let cuerpo_del_reporte = [];
    if(tipoReporte==='agrupa-meses'){
         datos.forEach(item => {
            const region = item?.region_iglesia || 'Sin Región';
            const distrito = item?.distrito_iglesia || 'Sin Distrito';
            const rango = item?.rango_ministro || 'Sin Rango';
            const meses = item?.cant_meses_diezmados || 0;
        
            if (!agrupado[meses]) agrupado[meses] = {};
            if (!agrupado[meses][region]) agrupado[meses][region] = {};
            if (!agrupado[meses][region][distrito]) agrupado[meses][region][distrito] = {};
            if (!agrupado[meses][region][distrito][rango]) agrupado[meses][region][distrito][rango] = []; // el último nodo tien la info, los otros solo clave valor para ir armando grupos
        
            const info_util = item;

            agrupado[meses][region][distrito][rango] = [...agrupado[meses][region][distrito][rango],info_util];
        });

        // agrupado es un objeto de claves valor anidadas en el que el valor del último nivel es lo que se va a tomar para imprimir o totalizar... el resto es para agrupar
        // Ejemplo 
        /*
        {
            region1:
                {distrito1:
                    {moe: ['pablo','gustavo','ezequiel'],
                     ma: ['a','b','c']
                    },
                 distrito2:
                    {moe:['e','f','g'],
                     ma:['h','i','j']
                    }
                }
            region2:
                {distrito1:
                    {moe:['h','l','m'],
                     ma:['ddda','tttb','asdfc'],
                    },
                 distrito2:
                    {moe:['uyra','b','yuedc'],
                     ma:['igra','reeb','zefc']
                    }
                }
        } 
        
        */
        cuerpo_del_reporte = generarCuerpoAgrupadoMeses(agrupado,tipoReporte);
        
    }else{
         datos.forEach(item => {
            const region = item?.region_iglesia || 'Sin Región';
            const distrito = item?.distrito_iglesia || 'Sin Distrito';
            const rango = item?.rango_ministro || 'Sin Rango';
            if (!agrupado[region]) agrupado[region] = {};
            if (!agrupado[region][distrito]) agrupado[region][distrito] = {};
            if (!agrupado[region][distrito][rango]) agrupado[region][distrito][rango] = []; // el último nodo tien la info, los otros solo clave valor para ir armando grupos
        
            const info_util = item;
            agrupado[region][distrito][rango] = [...agrupado[region][distrito][rango],info_util];
        });

        cuerpo_del_reporte = generarCuerpoAgrupadoStandard (agrupado,tipoReporte);

    
}
const encabezadoTabla = agregarEncabezadoPrincipal(tipoReporte); // se define afuera para usarlo en content

const docDefinition = {
    pageOrientation: 'portrait',
    pageMargins: [25, 90, 25, 50],

header: function (currentPage, pageCount, pageSize) {
  const headerBase = [
    // Título del PDF
    { text: tituloPDF, alignment: 'left', margin: [20, 30, 0, 2], fontSize: 10, bold: true },

    // Línea horizontal
    {
      width: pageSize.width,
      canvas: [
        { type: 'line', x1: 0, y1: 5, x2: pageSize.width, y2: 5, lineWidth: 1, lineColor: 'black' }
      ]
    },

    // Encabezado de columnas
    agregarEncabezadoPrincipal(tipoReporte)
  ];

  if (currentPage === 1) {
    return [
      {
        margin: [10, 50, 10, 0],
        columns: [
          {
            image: _imagenLogo,
            width: 50,
            alignment: 'left'
          },
          {
            text: 'Unión de las Asambleas de Dios - Reporte de aportantes',
            margin: [20, 0],
            alignment: 'left'
          }
        ]
      },
      ...headerBase
    ];
  }

  return headerBase;
},


  footer: function (currentPage, pageCount, pageSize) {
    return {
      margin: [0, 50, 30, 0],
      table: {
        widths: ['*', '*'],
        body: [
          [
            { text: fechaActual('DD/MM/YYYY'), alignment: 'right', fontSize: 8 },
            { text: 'Página ' + currentPage + ' de ' + pageCount, alignment: 'right', fontSize: 8 }
          ]
        ]
      },
      layout: 'noBorders'
    };
  },

  content: [
    // Línea divisoria decorativa
    {
      canvas: [
        { type: 'line', x1: 0, y1: 5, x2: 545, y2: 5, lineWidth: 1, lineColor: 'black' }
      ],
      margin: [0, 5, 0, 10]
    },
    
    encabezadoTabla,
    cuerpo_del_reporte
  ],

  styles: {
    header: {
      alignment: 'right'
    },
    center: {
      alignment: 'center',
      decoration: 'underline'
    },
    estilo_columna: {
      fontSize: 8,
      characterSpacing: -0.3
    },
    estilo_tabla: {
      fontSize: 8,
      characterSpacing: -0.3,
      margin: [0, 0, 0, 0]
    },
    encabezado_principal: {
      fontSize: 8,
      bold: true,
      color: 'gray',
      characterSpacing: -0.3,
      alignment: 'center'
    },
    anotherStyle: {
      fontSize: 15,
      bold: true
    },
    body: {
      lineHeight: 1.5
    },
    tableHeader: {
      bold: true,
      fontSize: 12
    },
    ['titulo-cabecera']: {
      bold: true,
      fontSize: 8
    }
  },

  images: {
    building: 'data:/Content/img/logo1.jpg'
  }
};
   
   pdfMake.createPdf(docDefinition).open()
}

const generarCuerpoAgrupadoStandard = (agrupado,tipoReporte)=>{
    let cuerpo_del_reporte = [];
    for (const region in agrupado) {
        for (const distrito in agrupado[region]) {
            for (const rango in agrupado[region][distrito]) {
                cuerpo_del_reporte.push(agregarLineaCabecera({region,distrito,rango}));
                
                const info_util = agrupado[region][distrito][rango]; // el último nivel tiene la info util objeto con datos
                
                const info_util_ordenada = info_util.sort((a, b) => 
                        tipoReporte=='agrupa-iglesias' ? salvarNull(a.iglesia).localeCompare(b.iglesia, 'es', { sensitivity: 'base' }) :  salvarNull(a.ministro).localeCompare(b.ministro, 'es', { sensitivity: 'base' })
                );

                info_util_ordenada.forEach(info=>{
                    cuerpo_del_reporte.push(agregarLineaPrincipal(info,tipoReporte))
                })
                
                cuerpo_del_reporte.push({canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 0.5,dash: {length: 1, space: 2},lineColor: 'black' }]})
            }
        }
    }

    return cuerpo_del_reporte

}

const generarCuerpoAgrupadoMeses = (agrupado,tipoReporte)=>{

    let cuerpo_del_reporte = [];

    for (const mes in agrupado) {
          cuerpo_del_reporte.push({
            style:'estilo_tabla',
            margin:[20,10,0,10],
            widths:[20,40],
            columns:[
                {text:'Meses diezmados:',width:100,fontSize: 10,decoration:'underline',margin: [5, 3, 5, 3]},
                {text:mes, italics: true, fontSize: 10,decoration:'underline', background: '#e0e0e0',margin: [5, 3, 5, 3]}
            ]
          })

          for (const region in agrupado[mes]) {
            for (const distrito in agrupado[mes][region]) {
                for (const rango in agrupado[mes][region][distrito]) {
                    cuerpo_del_reporte.push(agregarLineaCabecera({region,distrito,rango}));
                        const info_util = agrupado[mes][region][distrito][rango]; // el último nivel tiene la info util objeto con datos
                        
                        const info_util_ordenada = info_util.sort((a, b) => 
                            tipoReporte=='agrupa-iglesias' ?  salvarNull(a.iglesia).localeCompare(b.iglesia, 'es', { sensitivity: 'base' }) :  salvarNull(a.ministro).localeCompare(b.ministro, 'es', { sensitivity: 'base' })
                        );

                        info_util_ordenada.forEach(info=>{
                            cuerpo_del_reporte.push(agregarLineaPrincipal(info,tipoReporte))
                        })
                }
            }
          }
    }

    return cuerpo_del_reporte

}

const agregarLineaCabecera = (item)=>{
    return  { layout: 'noBorders',
                   style:'estilo_tabla',
                    table:{
                        widths: [150,150,150],
                        body:[
                                [
                                    agregarTituloCabecera({nombre:'Región:',valor:`Región ${item?.region}`}),
                                    agregarTituloCabecera({nombre:'Distrito::',valor:`${item?.distrito}`}),
                                    agregarTituloCabecera({nombre:'Rango:',valor:`${item?.rango}`}),
                                ]
                            ]
                        }
                }
}

const agregarTituloCabecera = (item)=>{
    return  	{
			alignment: 'justify',
            margin: [20, 10, 0, 10],
			columns: [
				{width: 40,text:item.nombre},
				{width: 140,text:item.valor,style:'titulo-cabecera'}
			]
		}
}

const agregarLineaPrincipal = (item,tipoReporte)=>{
    return  { layout: 'noBorders',
                   style:'estilo_tabla',
                    table:{
                        widths: [170,170,30,50,50,50],
                        margins:[0,0,0,0],
                        body:[
                                tipoReporte=='agrupa-iglesias' ? [
                                    item.iglesia,
                                    item?.ministro,
                                    item?.tiene_balance ? 'SI' : 'NO',
                                    item?.cant_meses_diezmados,
                                    item?.promedio_aporte.toFixed(2),
                                    item?.total_aportado.toFixed(2)
                                ] :
                                [
                                    item.ministro,
                                    item.iglesia,
                                    item?.tiene_balance ? 'SI' : 'NO',
                                    item?.cant_meses_diezmados,
                                    item?.promedio_aporte.toFixed(2),
                                    item?.total_aportado.toFixed(2)
                                ]
                            ]
                        }
                }
}

const agregarEncabezadoPrincipal = (tipoReporte) => {
  const columnas =
    tipoReporte === 'agrupa-iglesias'
      ? ['Iglesias', 'Ministro', 'Balance' , 'Meses diezmados', 'Promedio mensual', 'Aporte']
      : ['Ministro', 'Iglesias', 'Balance', 'Meses diezmados', 'Promedio mensual', 'Aporte'];

  return {
    style: 'encabezado_principal',
    layout: {
      hLineWidth: (i, node) => (i === 1 ? 1 : 0), // solo línea después del encabezado
      hLineColor: () => 'black',
      vLineWidth: () => 0
    },
    table: {
      widths: [170, 150, 30, 50, 50, 50],
      body: [
        columnas.map(texto => ({
          text: texto,
          alignment: 'center'
        }))
      ]
    },
    margin: [0, 10, 0, 0]
  };
};


const salvarNull = (valor) =>{
    return !valor ? '' : valor
}